import { ApiResult, HttpClient } from "../http.js";
import { PhotoDocumentDto, PhotoOwnerType } from "../types/photos.js";

export interface UploadPhotoPayload {
  file: FormData;
  ownerType: PhotoOwnerType;
  ownerId: string;
  category: string;
  caption?: string | null;
}

export class PhotosApi {
  constructor(private readonly http: HttpClient) {}

  list(ownerType: PhotoOwnerType, ownerId: string): Promise<ApiResult<PhotoDocumentDto[]>> {
    return this.http.get<PhotoDocumentDto[]>("/api/photos", { query: { ownerType, ownerId } });
  }

  upload(payload: UploadPhotoPayload): Promise<ApiResult<PhotoDocumentDto>> {
    return this.http.post<PhotoDocumentDto>("/api/photos", {
      query: {
        ownerType: payload.ownerType,
        ownerId: payload.ownerId,
        category: payload.category,
        caption: payload.caption ?? undefined,
      },
      body: payload.file,
    });
  }

  remove(id: string, ownerType: PhotoOwnerType): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/photos/${encodeURIComponent(id)}`, {
      query: { ownerType },
    });
  }
}
